var map = {
	"./app-icon.svg": 1712,
	"./caret-right-icon.svg": 1713,
	"./chrome-icon.webp": 1714,
	"./edge-icon.webp": 1715,
	"./firefox-icon.webp": 1716,
	"./opera-icon.webp": 1717,
	"./safari-icon.webp": 1718,
	"./unknown-icon.webp": 1719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1711;